export default __webpack_public_path__ + "static/media/qana-project-1.09a689db.jpg";